import { buildConnectAssistantMessagePatch } from '@/utils/connectAppAssistantPayload'

/** @param {import('./runResponseComponentDemoStream.js').DemoStreamCtx & {
 *   trimmed: string,
 *   connectContext?: unknown,
 * }} ctx */
export function runConnectAppTurn(ctx) {
  const { tid, pendingId, trimmed, connectContext, signal, session, setMessagesByThreadId } = ctx

  session.addTimeout(() => {
    if (signal.aborted) {
      session.dispose()
      return
    }
    setMessagesByThreadId((inner) => {
      const list = [...(inner[tid] ?? [])]
      const idx = list.findIndex((m) => m.id === pendingId)
      if (idx === -1) return inner
      const next = [...list]
      const prev = list[idx]
      const started =
        typeof prev.thinkingStartedAt === 'number' ? prev.thinkingStartedAt : prev.createdAt
      next[idx] = {
        ...next[idx],
        ...buildConnectAssistantMessagePatch(trimmed, connectContext ?? null, started),
      }
      return { ...inner, [tid]: next }
    })
    session.dispose()
  }, 500)
}
